import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section legal">
            <h2>Start your<br />therapy today</h2>
            
            <div className="app-google">
              <a href="https://play.google.com/store/apps/details?id=com.orangutan.aitherapist"  target='_blank' rel='noreferrer' className="store-button google-play">
                <img 
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
                  alt="Get it on Google Play" 
                />
              </a>
              </div>
              
          </div>
          
          <div className="footer-section product">
            <h3>Product</h3>
            <ul>
              <li><Link to="/chat" >Chat now</Link></li>
            </ul>
          </div>

          <div className="footer-section links">
            <h3>Legal</h3>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of service</Link></li>
              <li><a href="mailto:info@newtherapy.ai">Support</a></li>
            </ul>
          </div>

          <div className="footer-section resources">
            <h3>Resources</h3>
            <ul>
              <li><a href="https://988lifeline.org/" target="_blank" rel="noopener">Crisis Lifeline</a></li>
              <li><a href="https://www.thehotline.org/resources/help-my-ex-is-harassing-me-online/" target="_blank" rel="noopener">National Domestic Violence</a></li>
              <li><a href="tel:1-800-799-7233">1-800-799-7233</a></li>
              <li><a href="https://findahelpline.com/" target="_blank" rel="noopener">Find helpline</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; new therapy ai 2025, All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 